import {
  EcommerceGeneralSettingsAction,
  LOAD_ECOMMERCE_GENERAL_SETTINGS,
  LOAD_ECOMMERCE_GENERAL_SETTINGS_FAIL,
  LOAD_ECOMMERCE_GENERAL_SETTINGS_SUCCESS,
  LoadEcommerceGeneralSettings,
  LoadEcommerceGeneralSettingsFail,
  LoadEcommerceGeneralSettingsSuccess,
} from "../actions";

export interface IEcommerceGeneralSettingsEntityState {
  data: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceGeneralSettingsState {
  entities: { [websiteId: number]: IEcommerceGeneralSettingsEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceGeneralSettingsState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceGeneralSettingsState = initialState, action: EcommerceGeneralSettingsAction): IEcommerceGeneralSettingsState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_GENERAL_SETTINGS:
      payload = (<LoadEcommerceGeneralSettings>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_GENERAL_SETTINGS_SUCCESS:
      payload = (<LoadEcommerceGeneralSettingsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_GENERAL_SETTINGS_FAIL:
      payload = (<LoadEcommerceGeneralSettingsFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
